import React from 'react';

const ProductContext = React.createContext({
  i18n: {},
  productSettings: {}
});

export default ProductContext;